import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import brandService from "../services/brandSerivce"

const brandsCollectionName = 'brands';

export const useBrands = () => {
  return useQuery({
    queryKey: [brandsCollectionName],
    queryFn: () => brandService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAddBrand = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: brandService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [brandsCollectionName] });
    },
  });
};

export const useEditBrand = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: brandService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [brandsCollectionName] });
    },
  });
};

export const useDeleteBrand = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: brandService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [brandsCollectionName] });
    },
  });
};

export const useDevisionBrands = (devisionId) => {
  return useQuery({
    queryKey: [brandsCollectionName, devisionId],
    queryFn: () => brandService.getDevisionBrands(devisionId),
    enabled: !!devisionId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useTeamsBrands = (teamId) => {
  return useQuery({
    queryKey: [brandsCollectionName, teamId],
    queryFn: () => brandService.getTeamsBrands(teamId),
    enabled: !!teamId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useBrandNameById = (brandId) => {
  return useQuery({
    queryKey: [brandsCollectionName, brandId],
    queryFn: () => brandService.getNameById(brandId),
    enabled: !!brandId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

/**
 * Check if an order is available for a division + team
 */
export const useIsOrderAvailable = (divisionId, teamId, order, excludeBrandId = null) => {
  return useQuery({
    queryKey: [brandsCollectionName, 'orderCheck', divisionId, teamId, order, excludeBrandId],
    queryFn: () => brandService.isOrderAvailable(divisionId, teamId, order, excludeBrandId),
    enabled: !!divisionId && !!teamId && order !== undefined && order !== null,
    staleTime: 0,
  });
};

/**
 * Get the next order number for a division + team
 */
export const useNextOrder = (divisionId, teamId) => {
  return useQuery({
    queryKey: [brandsCollectionName, 'nextOrder', divisionId, teamId],
    queryFn: () => brandService.getNextOrder(divisionId, teamId),
    enabled: !!divisionId && !!teamId,
    staleTime: 0,
  });
};

/**
 * Update a brand's order
 */
export const useUpdateBrandOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ brandId, newOrder }) => brandService.updateOrder(brandId, newOrder),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [brandsCollectionName] });
    },
  });
};




